export default {
  path: '/insuranceClaims',
  title: '保险理赔',
  title_EN: 'Insurance Claims Management',
  icon: 'mdi-chart-line-stacked',
  access: '保险理赔',

  children: [
    {
      title: '基础信息',
      title_EN: 'Basic Information',
      icon: 'mdi-cash-clock',
      group: '/insuranceClaims',
      meta: { notShowInNav: false },
      children: [
        {
          path: '/general-info',
          name: 'insuranceClaims-general-info',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/insuranceClaims-general-info'
            ),
          meta: {
            title: '通用信息',
            title_EN: 'General Information',
            access: '通用信息',
            notShowInNav: false,
          },
        },
        {
          path: '/supplier-info',
          name: 'insuranceClaims-supplier-info',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/insuranceClaims-supplier-info'
            ),
          meta: {
            title: '供应商信息',
            title_EN: 'Supplier Information',
            access: '通用信息',
            notShowInNav: false,
          },
        },
        {
          path: '/container-type-info',
          name: 'container-type-info',
          component: () =>
            import('@/views/ship-owner/insurance-claims/container-type-info'),
          meta: {
            title: '箱型信息',
            title_EN: 'Container Type Information',
            access: '箱型信息',
            notShowInNav: false,
          },
        },
        {
          path: '/lawyer-info',
          name: 'insuranceClaims-lawyer-info',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/insuranceClaims-lawyer-info'
            ),
          meta: {
            title: '律师信息',
            title_EN: 'Lawyer Information',
            access: '律师信息',
            notShowInNav: false,
          },
        },
        {
          path: '/ship-info',
          name: 'insuranceClaims-ship-info',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/insuranceClaims-ship-info'
            ),
          meta: {
            title: '船舶信息',
            title_EN: 'Ship Information',
            access: '船舶信息',
            notShowInNav: false,
          },
        },
        {
          path: '/report-agency-info',
          name: 'insuranceClaims-report-agency-info',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/insuranceClaims-report-agency-info'
            ),
          meta: {
            title: '报案机构',
            title_EN: 'Report Agency Information',
            access: '报案机构信息',
            notShowInNav: false,
          },
        },
        {
          path: '/insurance-type-info',
          name: 'insuranceClaims-insurance-type-info',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/insurance-type-info.vue'
            ),
          meta: {
            title: '保险险种',
            title_EN: 'Insurance Type Information',
            access: '保险险种信息',
            notShowInNav: false,
          },
        },
        {
          path: '/insurance-type-detail/:id',
          name: 'insuranceClaims-insurance-type-detail',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/insurance-type-detail.vue'
            ),
          meta: {
            title: '保险险种详情',
            title_EN: 'Insurance Type Detail',
            access: '保险险种信息',
            notShowInNav: true,
          },
        },
      ],
    },
    {
      title: '客户管理',
      title_EN: 'Customer Management',
      icon: 'mdi-account-group',
      group: '/insuranceClaims',
      meta: { notShowInNav: false },
      children: [
        {
          path: '/customer-info',
          name: 'insuranceClaims-customer-info',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/insuranceClaims-customer-info'
            ),
          meta: {
            title: '客户信息',
            title_EN: 'Customer Information',
            access: '客户信息',
            notShowInNav: false,
          },
        },
      ],
    },
    {
      title: '案件管理',
      title_EN: 'Case Management',
      icon: 'mdi-briefcase-search',
      group: '/insuranceClaims',
      meta: { notShowInNav: false },
      children: [
        {
          path: '/claim-case-management',
          name: 'insuranceClaims-claim-case-management',
          component: () =>
            import('@/views/ship-owner/insurance-claims/claim-case-management'),
          meta: {
            title: '保险理赔案件',
            title_EN: 'Insurance Claim Case',
            access: '保险理赔',
            notShowInNav: false,
          },
        },
        {
          path: '/claim-case-management-detail/:id?',
          name: 'insuranceClaims-claim-case-management-detail',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/claim-case-management-detail'
            ),
          meta: {
            title: '保险理赔案件详情',
            title_EN: 'Insurance Claim Case Detail',
            access: '保险理赔',
            notShowInNav: true,
          },
        },
        {
          path: '/claim-litigation-management',
          name: 'insuranceClaims-claim-litigation-management',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/claim-litigation-management'
            ),
          meta: {
            title: '诉讼案件',
            title_EN: 'Litigation Case',
            access: '保险理赔',
            notShowInNav: false,
          },
        },
        {
          path: '/claim-litigation-management-detail/:id?',
          name: 'insuranceClaims-claim-litigation-management-detail',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/claim-litigation-management-detail'
            ),
          meta: {
            title: '诉讼案件详情',
            title_EN: 'Litigation Case Detail',
            access: '保险理赔',
            notShowInNav: true,
          },
        },
      ],
    },
    {
      title: '保险管理',
      title_EN: 'Insurance Management',
      icon: 'mdi-shield-check',
      group: '/insuranceClaims',
      meta: { notShowInNav: false },
      children: [
        {
          path: '/renewal-management',
          name: 'insuranceClaims-renewal-management',
          component: () =>
            import('@/views/ship-owner/insurance-claims/renewal-management'),
          meta: {
            title: '续保管理',
            title_EN: 'Renewal Management',
            access: '续保管理',
            notShowInNav: false,
          },
        },
        {
          path: '/renewal-management-detail/:id?',
          name: 'insuranceClaims-renewal-management-detail',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/renewal-management-detail'
            ),
          meta: {
            title: '续保管理详情',
            title_EN: 'Renewal Management Detail',
            access: '续保管理',
            notShowInNav: true,
          },
        },
        {
          path: '/policy-other-management',
          name: 'insuranceClaims-policy-other-management',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/policy-other-management'
            ),
          meta: {
            title: '其他保单',
            title_EN: 'Other Policy Management',
            access: '其他保单',
            notShowInNav: false,
          },
        },
        {
          path: '/policy-other-management-detail/:id?',
          name: 'insuranceClaims-policy-other-management-detail',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/policy-other-management-detail'
            ),
          meta: {
            title: '其他保单详情',
            title_EN: 'Other Policy Management Detail',
            access: '其他保单',
            notShowInNav: true,
          },
        },
        {
          path: '/policy-tcl-management',
          name: 'insuranceClaims-policy-tcl-management',
          component: () =>
            import('@/views/ship-owner/insurance-claims/policy-tcl-management'),
          meta: {
            title: 'TCL保单',
            title_EN: 'TCL Policy Management',
            access: 'TCL保单',
            notShowInNav: false,
          },
        },
        {
          path: '/policy-tcl-management-detail/:id?',
          name: 'insuranceClaims-policy-tcl-management-detail',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/policy-tcl-management-detail'
            ),
          meta: {
            title: 'TCL保单详情',
            title_EN: 'TCL Policy Management Detail',
            access: 'TCL保单',
            notShowInNav: true,
          },
        },
        {
          path: '/policy-premium-management',
          name: 'insuranceClaims-policy-premium-management',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/policy-premium-management'
            ),
          meta: {
            title: '保费管理',
            title_EN: 'Premium Management',
            access: '保费管理',
            notShowInNav: false,
          },
        },
        {
          path: '/policy-premium-management-detail/:id?',
          name: 'insuranceClaims-policy-premium-management-detail',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/policy-premium-management-detail'
            ),
          meta: {
            title: '保费管理详情',
            title_EN: 'Premium Management Detail',
            access: '保费管理',
            notShowInNav: true,
          },
        },
        {
          path: '/policy-premium-payment',
          name: 'insuranceClaims-policy-premium-payment',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/policy-premium-payment'
            ),
          meta: {
            title: '保费支付',
            title_EN: 'Premium Payment',
            access: '保费支付',
            notShowInNav: false,
          },
        },
        {
          path: '/policy-premium-payment-summary-send',
          name: 'insuranceClaims-policy-premium-payment-summary-send',
          component: () =>
            import(
              '@/views/ship-owner/insurance-claims/policy-premium-payment-summary-send'
            ),
          meta: {
            title: '保费支付汇总发送信息',
            title_EN: 'Premium Payment Summary Send Info',
            access: '保费支付',
            notShowInNav: true,
          },
        },
      ],
    },
  ],
}
